import { request } from "@esri/arcgis-rest-request";

export const UpdateWwtp = async (payLoad, Config) =>  {
    
    console.log("Payload:", JSON.stringify(payLoad));

  try {  
        const resp = await request(`${Config.server.portalUrl}/sharing/servers/${Config.server.wwtpFeaturePortalItem}/rest/services/S4L/S4L_CS_Boundaries/FeatureServer/2/updateFeatures`,{
            httpMethod: 'POST',
            params: {
                token: Config.server.apiKey,
                features: payLoad,
                f: "json"
           }});
        console.log(resp);
        if (resp.updateResults[0].success)
            return true;
        else
            return false;
    } catch (error) {
        console.log(error);
        return false;
    } 

}


